<template>
  <div class="booking">
    <div class="header">
      <div
        class="title-box"
        @click="$router.push({ path: '/photographer/booking' })"
        :class="{ active: $route.path == '/photographer/booking' }"
      >
        <span class="title">UP COMING EVENT</span>
      </div>
      <div
        class="title-box"
        @click="$router.push({ path: '/photographer/booking/upload' })"
        :class="{ active: $route.path == '/photographer/booking/upload' }"
      >
        <span class="title">NEED TO UPLOAD</span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  components: {
    // BookingBox
  },
  name: 'booking',
  data() {
    return {
      bookings: [1, 2, 3]
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.booking {
  width: 100%;
  height: 100%;
  /*border: 1px dotted red;*/
  .header {
    display: flex;
    .title-box {
      width: 50%;
      height: 60px;
      background-color: #ffffff;
      border: solid 1px #e7e7e7;
      text-align: center;
      cursor: pointer;
      &:nth-child(2) {
        border-left: 0;
      }
      .title {
        line-height: 60px;
        font-size: 16px;
        letter-spacing: 1px;
        text-align: center;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        color: #000000;
      }

      &.active {
        span {
          font-weight: 600;
          color: #ab08b6;
        }
        border-bottom: 0;
      }
    }
  }
}
</style>
